(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

var _accordion = _interopRequireDefault(require("./temp-modules/accordion"));
var _headerActive = _interopRequireDefault(require("./temp-modules/header-active"));
var _slider = _interopRequireDefault(require("./temp-modules/slider"));
var _tabs = _interopRequireDefault(require("./temp-modules/tabs"));
var _select = _interopRequireDefault(require("./temp-modules/select"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
// You can write a call and import your functions in this file.
//
// This file will be compiled into app.js and will not be minified.
// Feel free with using ES6 here.

(function ($) {
  // When DOM is ready
  $(function () {
    _accordion["default"].init();
    _tabs["default"].init();
    _select["default"].init();
    _headerActive["default"].init();
    _slider["default"].init();
  });
})(jQuery);

},{"./temp-modules/accordion":2,"./temp-modules/header-active":3,"./temp-modules/select":4,"./temp-modules/slider":5,"./temp-modules/tabs":6}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var CLASS_TITLE = 'accordion__title';
var CLASS_CONTENT = 'accordion__content';
var CLASS_ACTIVE = 'active';
var CLASS_ACCORDION_ALL = 'accordion_all';
var ACCORDION = document.getElementsByClassName('accordion');
var accordion = function () {
  var accordionInit = function accordionInit() {
    var _loop = function _loop() {
      var contentAccordion = ACCORDION[item].getElementsByClassName(CLASS_CONTENT);
      var titleAccordion = ACCORDION[item].getElementsByClassName(CLASS_TITLE);
      if (ACCORDION[item].classList.contains(CLASS_ACCORDION_ALL)) {
        var showAllAccordion = function showAllAccordion(toggle) {
          var currentAccordion = document.getElementById(toggle);
          currentAccordion.classList.toggle(CLASS_ACTIVE);
        };
        for (var i = 0; i < titleAccordion.length; i += 1) {
          titleAccordion[i].addEventListener('click', function () {
            showAllAccordion(this.dataset.accordion);
            this.classList.toggle(CLASS_ACTIVE);
          });
        }
      } else {
        var showAccordion = function showAccordion(toggle) {
          var currentAccordion = document.getElementById(toggle);
          if (currentAccordion.classList.contains(CLASS_ACTIVE)) {
            currentAccordion.classList.remove(CLASS_ACTIVE);
          } else {
            for (var _i = 0; _i < contentAccordion.length; _i += 1) {
              contentAccordion[_i].classList.remove(CLASS_ACTIVE);
            }
            currentAccordion.classList.add(CLASS_ACTIVE);
          }
        };
        var _loop2 = function _loop2(_i2) {
          titleAccordion[_i2].addEventListener('click', function (_ref) {
            var target = _ref.target;
            showAccordion(target.dataset.accordion);
            if (target.classList.contains(CLASS_ACTIVE)) {
              titleAccordion[_i2].classList.remove(CLASS_ACTIVE);
            } else {
              for (var j = 0; j < titleAccordion.length; j += 1) {
                titleAccordion[j].classList.remove(CLASS_ACTIVE);
              }
              titleAccordion[_i2].classList.add(CLASS_ACTIVE);
            }
          });
        };
        for (var _i2 = 0; _i2 < titleAccordion.length; _i2 += 1) {
          _loop2(_i2);
        }
      }
    };
    for (var item = 0; item < ACCORDION.length; item += 1) {
      _loop();
    }
  };
  var init = function init() {
    if (ACCORDION.length > 0) {
      accordionInit();
    }
  };
  return {
    init: init
  };
}();
var _default = exports["default"] = accordion;

},{}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var parentItems = document.querySelectorAll('.header-menu-item-parent');
var header = document.querySelector('.header');
var headerActive = function () {
  var headerActiveFunc = function headerActiveFunc() {
    if (parentItems) {
      parentItems.forEach(function (el) {
        el.addEventListener('mouseenter', function () {
          el.classList.add('active');
          header.classList.add('open');
        });
        el.addEventListener('mouseleave', function () {
          el.classList.remove('active');
          header.classList.remove('open');
        });
      });
    }
  };
  var init = function init() {
    headerActiveFunc();
  };
  return {
    init: init
  };
}();
var _default = exports["default"] = headerActive;

},{}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var select = function () {
  var selectInit = function selectInit() {
    var buttons = document.querySelectorAll('.main-collection-filter-button');
    var dropdowns = document.querySelectorAll('.main-collection-filter-dropdown');
    var closeAllDropdowns = function closeAllDropdowns() {
      dropdowns.forEach(function (dropdown) {
        dropdown.style.display = 'none';
      });
    };
    buttons.forEach(function (button) {
      var dropdownMenu = button.nextElementSibling;
      button.addEventListener('click', function (event) {
        event.stopPropagation();
        var isOpen = dropdownMenu.style.display === 'block';
        closeAllDropdowns();
        dropdownMenu.style.display = isOpen ? 'none' : 'block';
      });
    });
    document.addEventListener('click', function (event) {
      var clickedInsideDropdown = Array.from(dropdowns).some(function (dropdown) {
        return dropdown.contains(event.target);
      });
      if (!clickedInsideDropdown) {
        closeAllDropdowns();
      }
    });
  };
  var init = function init() {
    selectInit();
  };
  return {
    init: init
  };
}();
var _default = exports["default"] = select;

},{}],5:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var swiperSlider = function () {
  var accountantInit = new Swiper('.js-accountant-slider', {
    slidesPerView: 2,
    spaceBetween: 20,
    speed: 800,
    centerInsufficientSlides: true,
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true
    },
    breakpoints: {
      768: {
        spaceBetween: 40,
        slidesPerView: 3
      }
    }
  });
  var productsSliderInit = new Swiper('.products-slider', {
    speed: 300,
    breakpoints: {
      320: {
        spaceBetween: 20,
        slidesPerView: 2
      },
      768: {
        spaceBetween: 20,
        slidesPerView: 2
      },
      1024: {
        spaceBetween: 20,
        slidesPerView: 4
      }
    },
    navigation: {
      nextEl: '.products-btn-next',
      prevEl: '.products-btn-prev'
    }
  });
  var categorySlider = new Swiper('.shop-category-list', {
    speed: 300,
    breakpoints: {
      320: {
        spaceBetween: 20,
        slidesPerView: 2
      },
      768: {
        spaceBetween: 32,
        slidesPerView: 4
      },
      1024: {
        spaceBetween: 56,
        slidesPerView: 6
      }
    },
    navigation: {
      nextEl: '.products-btn-next',
      prevEl: '.products-btn-prev'
    }
  });
  var slideshowSlider = new Swiper('.slideshow-slider', {
    speed: 300,
    loop: true,
    navigation: {
      nextEl: '.slideshow-btn-next',
      prevEl: '.slideshow-btn-prev'
    },
    pagination: {
      clickable: true,
      el: '.slideshow-pagination'
    }
  });
  
  function initializeSwiper() {
    const productSlider = new Swiper('.product-slider', {
      speed: 300,
      breakpoints: {
        320: {
          spaceBetween: 20,
          slidesPerView: 2
        },
        768: {
          spaceBetween: 20,
          slidesPerView: 2
        },
        1024: {
          spaceBetween: 20,
          slidesPerView: 4
        }
      },
      navigation: {
        nextEl: '.product-slider-body-btn-next',
        prevEl: '.product-slider-body-btn-prev'
      }
    });
  }
  
  // Создаем observer для отслеживания изменений в DOM
  const observer = new MutationObserver((mutations) => {
    if (document.querySelector('.product-slider')) {
      observer.disconnect();
      initializeSwiper();
    }
  });
  
  // Начинаем наблюдение
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  let productCards = document.querySelectorAll('.main-collection-item');  

  if (productCards) {  
    productCards.forEach(el => {  
      let quickBtn = el.querySelector('.main-collection-item-button-quick');  
      let variantsWrappers = el.querySelectorAll('.product-variants-wrapper'); // Select all variants wrappers  
      let price = el.querySelector('.main-collection-item-price');
  
      if (quickBtn) {  
        quickBtn.addEventListener('click', () => {  
          quickBtn.classList.toggle('active');  
  
          // Activate all variants wrappers  
          variantsWrappers.forEach(wrapper => {  
            wrapper.classList.toggle('active');  
          });  
        });  
      }  
  
      // Loop through each variants wrapper  
      variantsWrappers.forEach(wrapper => {  
        let variantsWrapperClose = wrapper.querySelector('.product-variants-wrapper-close'); // Select close button within the current wrapper  
        let select = wrapper.querySelector('.product-variants-select'); // Select variants select within the current wrapper  
        let productVariantId = wrapper.querySelector('.product-variant-id'); // Select product variant id within the current wrapper  
  
        if (variantsWrapperClose) {  
          variantsWrapperClose.addEventListener('click', () => {  
            quickBtn.classList.remove('active');  
  
            // Deactivate the current variants wrapper  
            wrapper.classList.remove('active');  
          });  
        }  
  
        if (select) {  
          select.addEventListener('change', () => {  
            let selectedOption = select.options[select.selectedIndex];  
            let selectedOptionId = selectedOption.id;  
            let selectedOptionValue = selectedOption.value;
  
            if (productVariantId) {  
              productVariantId.value = selectedOptionId;  
            }  

            if(price) {
              price.innerText = selectedOptionValue;
            }
          });  
        }  
      });  
    });  
  }

    /**
   * Скрипт для показа wholesale popup при сумме заказа более 700
   * Добавьте этот скрипт в конец файла cart.js или включите его отдельно
   */
  
  /**
 * Скрипт для показа wholesale popup при сумме заказа более 700
 * Добавьте этот скрипт в конец файла cart.js или включите его отдельно
 */

  document.addEventListener('DOMContentLoaded', function() {

    let saleModal = document.querySelector('#sale-popup');
    let saleToggle = document.querySelector('.sale-popup-toggle');

    if(saleToggle){
      saleToggle.addEventListener('click', () => {
        saleModal.classList.add('active');
      })
    }

    if(saleModal) {
      const close = saleModal.querySelector('.newsletter-popup-close');
  
      if(close) {
        close.addEventListener('click', () => {
          document.body.style.overflow = '';
          document.body.style.transform = '';
          saleModal.classList.remove('active');
        });
      }
    
      document.addEventListener('click', (e) => {
        if (e.target == saleModal) {
          document.body.style.overflow = '';
          document.body.style.transform = '';
          saleModal.classList.remove('active');
        }
      });
    }

    const newsletterForm = document.querySelector('#sale-popup .contact-section-form');
  
    if (newsletterForm) {
      newsletterForm.addEventListener('submit', function(e) {
        e.preventDefault(); // Prevent default form submission
        
        // Get form data
        const formData = new FormData(newsletterForm);
        const email = formData.get('contact[email]');
        
        // Create AJAX request
        fetch(window.location.pathname, {
          method: 'POST',
          body: formData,
          headers: {
            'Accept': 'application/json'
          }
        })
        .then(response => {
          if (response.ok) {
            return response.json();
          }
          throw new Error('Network response was not ok');
        })
        .then(data => {
          // Handle successful submission
          const successMessage = document.getElementById('Newsletter-success--{{ section.id }}');
          
          if (!successMessage) {
            // Create success message if it doesn't exist
            const successDiv = document.createElement('h6');
            successDiv.className = 'newsletter-form__message newsletter-form__message--success form__message';
            successDiv.id = 'Newsletter-success--{{ section.id }}';
            
            // Add SVG wrapper and success message
            successDiv.innerHTML = `
              <span class="svg-wrapper">
                {{- 'icon-success.svg' | inline_asset_content -}}
              </span>
              {{ settings.sale_popup_discount_code }}
            `;
            
            // Display the discount code
            newsletterForm.appendChild(successDiv);
          } else {
            // Show existing success message
            successMessage.style.display = 'block';
          }
          
          // Clear the input field
          newsletterForm.querySelector('input[type="email"]').value = '';
        })
        .catch(error => {
          console.error('Error during form submission:', error);
          
          // Handle error submission
          const errorMessage = document.getElementById('Newsletter-error--{{ section.id }}');
          
          if (!errorMessage) {
            // Create error message if it doesn't exist
            const errorDiv = document.createElement('small');
            errorDiv.className = 'newsletter-form__message form__message';
            errorDiv.id = 'Newsletter-error--{{ section.id }}';
            
            // Add SVG wrapper and error message
            errorDiv.innerHTML = `
              <span class="svg-wrapper">
                {{- 'icon-error.svg' | inline_asset_content -}}
              </span>
              There was a problem submitting your email
            `;
            
            newsletterForm.appendChild(errorDiv);
          } else {
            // Show existing error message
            errorMessage.style.display = 'block';
          }
        });
      });
    }
  
    const modal = document.querySelector('#wholesale-popup');
    if(modal) {
  
      const close = modal.querySelector('.newsletter-popup-close');
  
      if(close) {
        close.addEventListener('click', () => {
          document.body.style.overflow = '';
          document.body.style.transform = '';
          modal.classList.remove('active');
          
          // Сохраняем в localStorage что попап был показан
          localStorage.setItem('wholesale_popup_shown', 'true');
        });
      }
    
      document.addEventListener('click', (e) => {
        if (e.target == modal) {
          document.body.style.overflow = '';
          document.body.style.transform = '';
          modal.classList.remove('active');
          
          // Сохраняем в localStorage что попап был показан
          localStorage.setItem('wholesale_popup_shown', 'true');
        }
      });
    }
    
    // Функция для проверки и показа popup
    function checkCartAndShowPopup() {
      console.log("Проверка суммы корзины...");
      
      // Проверяем, был ли уже показан попап этому клиенту
      if (localStorage.getItem('wholesale_popup_shown') === 'true') {
        console.log("Попап уже был показан этому клиенту");
        return; // Прекращаем выполнение функции
      }
      
      // Получение суммы корзины через Shopify API
      let cartTotal = 0;
      
      // Вариант 1: Проверяем, доступен ли объект корзины Shopify
      if (typeof Shopify !== 'undefined' && Shopify.cart) {
        cartTotal = Shopify.cart.total_price / 100; // Shopify хранит цены в центах
        console.log("Сумма корзины из Shopify API:", cartTotal);
      } 
      // Вариант 2: Пытаемся найти элемент цены в DOM
      else {
        // Проверяем различные возможные селекторы для цены
        const selectors = [
          '.totals__total-value',
          'p.totals__total-value', 
          '.cart-footer__total-value',
          '.totals p',
          '[data-cart-total]',
          '.total-row .price'
        ];
        
        let totalPriceElement = null;
        
        for (const selector of selectors) {
          const element = document.querySelector(selector);
          if (element && element.textContent) {
            totalPriceElement = element;
            console.log("Найден элемент с ценой:", selector);
            break;
          }
        }
        
        if (totalPriceElement) {
          const priceText = totalPriceElement.textContent.trim();
          console.log("Текст цены:", priceText);
          
          // Извлекаем число из текста
          const matches = priceText.match(/[\d\s,.]+/);
          if (matches) {
            // Очищаем строку от всего, кроме цифр, точек и запятых
            let cleanPrice = matches[0].replace(/\s/g, '');
            
            // Заменяем запятые на точки
            cleanPrice = cleanPrice.replace(/,/g, '.');
            
            // Обрабатываем случай с несколькими точками (разные форматы локалей)
            const parts = cleanPrice.split('.');
            if (parts.length > 1) {
              const decimal = parts.pop();
              const integer = parts.join('');
              cartTotal = parseFloat(integer + '.' + decimal);
            } else {
              cartTotal = parseFloat(cleanPrice);
            }
            
            console.log("Извлеченная сумма:", cartTotal);
          }
        } else {
          console.log("Элемент с ценой не найден");
        }
      }
      
      // Вариант 3: Используем fetch для получения данных корзины через Shopify AJAX API
      if (!cartTotal) {
        fetch('/cart.js')
          .then(response => response.json())
          .then(cart => {
            cartTotal = cart.total_price / 100;
            console.log("Сумма корзины из AJAX API:", cartTotal);
            showPopupIfNeeded(cartTotal);
          })
          .catch(error => {
            console.error("Ошибка при получении данных корзины:", error);
          });
      } else {
        showPopupIfNeeded(cartTotal);
      }
    }
    
    // Функция показа popup если сумма больше порога
    function showPopupIfNeeded(cartTotal) {
      // Popup элемент
      const wholesalePopup = document.querySelector('#wholesale-popup');
      if (!wholesalePopup) {
        console.log("Popup элемент не найден");
        return;
      }
      
      // Показываем popup если сумма больше 700 и он еще не был показан
      if (cartTotal > 700 && localStorage.getItem('wholesale_popup_shown') !== 'true') {
        console.log("Показываем popup: сумма", cartTotal, "больше 700");
        wholesalePopup.classList.add('active');
      } else {
        console.log("Скрываем popup: сумма", cartTotal, "меньше 700 или попап уже был показан");
        wholesalePopup.classList.remove('active');
      }
    }
    
    // Проверяем при загрузке страницы
    setTimeout(checkCartAndShowPopup, 1000); // Задержка для уверенности, что DOM полностью загружен
    
    // Обработчик события обновления корзины Shopify
    document.addEventListener('cart:updated', function(event) {
      console.log("Событие обновления корзины");
      checkCartAndShowPopup();
    });
    
    // Слушаем клики на кнопках добавления/удаления товаров
    document.addEventListener('click', function(event) {
      if (
        event.target.matches('.quantity__button') || 
        event.target.matches('.cart-remove-button') ||
        event.target.closest('.quantity__button') ||
        event.target.closest('.cart-remove-button')
      ) {
        setTimeout(checkCartAndShowPopup, 1000); // Задержка чтобы дать время на обновление корзины
      }
    });
    
    // Наблюдаем за изменениями в корзине
    const cartObserver = new MutationObserver(function(mutations) {
      console.log("Обнаружены изменения в корзине");
      setTimeout(checkCartAndShowPopup, 500);
    });
    
    // Элемент корзины для наблюдения
    const cartElement = document.querySelector('.cart-drawer__form') || 
                        document.querySelector('.cart__contents') ||
                        document.querySelector('#CartDrawer');
                        
    if (cartElement) {
      console.log("Настройка наблюдателя за корзиной");
      cartObserver.observe(cartElement, { 
        subtree: true, 
        childList: true,
        characterData: true 
      });
    } else {
      console.log("Элемент корзины не найден для наблюдения");
    }
  });
 
  var init = function init() {};
  return {
    init: init
  };
}();
var _default = exports["default"] = swiperSlider;

},{}],6:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var ACTIVE = 'active';
var swiperInstances = []; // сюда сохраняем Swiper'ы

// Инициализация всех слайдеров в табах
let tabsSliders = document.querySelectorAll('.tabs-tab-content-slider');
if (tabsSliders.length) {
  tabsSliders.forEach((el) => {
    let btnPrev = el.querySelector('.products-btn-prev');
    let btnNext = el.querySelector('.products-btn-next');

    let tabSlider = new Swiper(el, {
      speed: 300,
      breakpoints: {
        320: {
          spaceBetween: 20,
          slidesPerView: 2
        },
        768: {
          spaceBetween: 32,
          slidesPerView: 2
        },
        1024: {
          spaceBetween: 32,
          slidesPerView: 3
        }
      },
      navigation: {
        nextEl: btnNext,
        prevEl: btnPrev
      }
    });

    swiperInstances.push({
      element: el,
      instance: tabSlider
    });
  });
}

var tabs = function () {
  var tabsUnit = function tabsUnit() {
    var TAB = document.querySelectorAll('.js-tabs-btn');
    for (var i = 0; i < TAB.length; i++) {
      var currentTab = TAB[i];
      currentTab.addEventListener('click', function (e) {
        for (var y = 0; y < TAB.length; y++) {
          var _currentTab = TAB[y];
          var currentTabContent = document.querySelector("." + _currentTab.getAttribute('data-tab'));
          _currentTab.classList.remove(ACTIVE);
          currentTabContent.classList.remove(ACTIVE);
        }

        e.currentTarget.classList.add(ACTIVE);
        var target = e.currentTarget.getAttribute('data-tab');
        var targetContent = document.querySelector("." + target);
        targetContent.classList.add(ACTIVE);

        swiperInstances.forEach(item => {
          if (targetContent.contains(item.element)) {
            item.instance.update();
          }
        });
      });
    }
  };

  var init = function init() {
    tabsUnit();
  };

  return {
    init: init
  };
}();

var _default = exports["default"] = tabs;

},{}]},{},[1]);
